import React from "react";
import { motion } from "framer-motion";

export const EPIC = "bg-white rounded-3xl border border-slate-200/80 shadow-[0_4px_20px_-4px_rgba(15,23,42,0.06)]";
export const stagger = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.07 } } };
export const fadeUp = { hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.25, 1, 0.5, 1] } } };

export function EpicPage({ children, className = "", testId }) {
  return <motion.div initial="hidden" animate="show" variants={stagger} className={`space-y-6 ${className}`} data-testid={testId}>{children}</motion.div>;
}

export function EpicHero({ overline, title, accent, subtitle, children, aside, glow = "bg-emerald-400/15", glow2 = "bg-cyan-400/10", testId }) {
  return (
    <motion.section variants={fadeUp} className={`${EPIC} relative overflow-hidden p-6 sm:p-8`} data-testid={testId}>
      <div className={`absolute -top-24 -right-20 w-72 h-72 rounded-full ${glow} blur-3xl pointer-events-none`} />
      <div className={`absolute -bottom-28 left-1/4 w-80 h-80 rounded-full ${glow2} blur-3xl pointer-events-none`} />
      <div className="relative flex flex-wrap items-end justify-between gap-5">
        <div className="min-w-0 max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-700">{overline}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold tracking-tight text-slate-900 mt-1 leading-[1.08]">{title}{accent && <> <span className="text-emerald-600">{accent}</span></>}</h1>
          {subtitle && <p className="text-slate-600 mt-2">{subtitle}</p>}
          {children && <div className="mt-5 flex flex-wrap items-center gap-2">{children}</div>}
        </div>
        {aside}
      </div>
    </motion.section>
  );
}

export function EpicCard({ children, className = "", testId, ...rest }) {
  return <motion.section variants={fadeUp} className={`${EPIC} ${className}`} data-testid={testId} {...rest}>{children}</motion.section>;
}

export function EpicTitle({ icon: Icon, tone = "text-emerald-600", children, right }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <h2 className="text-base md:text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2">{Icon && <Icon className={`w-5 h-5 ${tone}`} />} {children}</h2>
      {right}
    </div>
  );
}

export const Chip = ({ children, dark = false, className = "", ...rest }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full text-xs font-semibold px-3 py-1.5 ${dark ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-700"} ${className}`} {...rest}>{children}</span>
);
